export default "__VITE_ASSET__37538d55__"